import React from "react";
import { Badge } from "react-bootstrap";

const variants = [
  "primary",
  "secondary",
  "success",
  "danger",
  "warning",
  "info",
  "dark",
];

const getVariant = (text) => {
  const id =
    (text[0].toLowerCase().charCodeAt(0) - "a".charCodeAt(0)) % variants.length;
  return variants[id];
};

const TagDisplay = ({ tags }) => {
  return (
    <div className="mb-3 mt-3">
      {tags.map((tag, id) => (
        <span key={id}>
          <Badge className="mr-1 p-1" variant={getVariant(tag)}>
            {tag}
          </Badge>
        </span>
      ))}
    </div>
  );
};

export default TagDisplay;
